import React from 'react';
import SelectedTable from './selected_table';

class InventoryCategoriesTemplate extends React.Component {
  render() {
    return ( 
			<div>
        <SelectedTable />		
			</div>
    );
  }
}
export default InventoryCategoriesTemplate;